import axios from '../utils/axiosClient';
import endpoints from './endpoints';

const { getAllCurrencyExchangeRequests } = endpoints;

const fetchAllCurrencyExchangeRequests = async (params: any) => {
  try {
    const response = await axios.get(getAllCurrencyExchangeRequests, { params });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const currencyExchangeServices = {
  fetchAllCurrencyExchangeRequests,
};

export default currencyExchangeServices;
